<template>
  <ModalTemplate
    :isOpen="show"
    :on-close="closeModal"
    :modalMainContainerClass="''"
    :title="$t('ORDER.DETAILS.DELIVERY_MODAL.HEADER.TITLE')"
  >
    <!-- <woot-modal-header
      :header-title="$t('ORDER.DETAILS.DELIVERY_MODAL.HEADER.TITLE')"
      :header-content="$t('')"
    /> -->
    <div class="mt_20">
        <InputField
            v-model="order.shipment_address.line1"
            :error="$v.order.shipment_address.line1.$error? $t('ORDER.DETAILS.DELIVERY_MODAL.LINE1.ERR_MSG'):''"
            :label="$t('ORDER.DETAILS.DELIVERY_MODAL.LINE1.LABEL')"
            :placeholder="$t('ORDER.DETAILS.DELIVERY_MODAL.LINE1.PLACEHOLDER')"
            @input="onChange"
        />
        <InputField
            v-model="order.shipment_address.city"
            :error="$v.order.shipment_address.city.$error? $t('ORDER.DETAILS.DELIVERY_MODAL.CITY.ERR_MSG'):''"
            :label="$t('ORDER.DETAILS.DELIVERY_MODAL.CITY.LABEL')"
            :placeholder="$t('ORDER.DETAILS.DELIVERY_MODAL.CITY.PLACEHOLDER')"
            @input="onChange"
        />
        <InputField
            v-model="order.shipment_address.state"
            :error="$v.order.shipment_address.state.$error? $t('ORDER.DETAILS.DELIVERY_MODAL.STATE.ERR_MSG'):''"
            :label="$t('ORDER.DETAILS.DELIVERY_MODAL.STATE.LABEL')"
            :placeholder="$t('ORDER.DETAILS.DELIVERY_MODAL.STATE.PLACEHOLDER')"
            @input="onChange"
        />
        <MultiselectDropdown
          :label="$t('ORDER.DETAILS.DELIVERY_MODAL.COUNTRY.LABEL')"
          :error="$v.order.shipment_address.country.$error ? 'ORDER.DETAILS.DELIVERY_MODAL.COUNTRY.ERR_MSG' : ''"
        >
          <select
                class="font_regular font_500 text_14"
                v-model="order.shipment_address.country"
                :disabled="false"
              >
              <option
                v-for="country in merchant.permissible_countries"
                :key="country"
                :value="country"
              >
                {{country}}
              </option>
            </select>
        </MultiselectDropdown>
        <InputField
            v-model="order.shipment_address.postal_code"
            :error="$v.order.shipment_address.postal_code.$error? $t('ORDER.DETAILS.DELIVERY_MODAL.POSTAL_CODE.ERR_MSG'):''"
            :label="$t('ORDER.DETAILS.DELIVERY_MODAL.POSTAL_CODE.LABEL')"
            :placeholder="$t('ORDER.DETAILS.DELIVERY_MODAL.POSTAL_CODE.PLACEHOLDER')"
            @input="onChange"
        />

        <hr v-if="isDelvaFetched" class="section_divider">
        <div v-if="isDelvaFetched">
          <label class="deliveryOptionLabel">
            {{$t('ORDER.DETAILS.DELIVERY_MODAL.DELOVERY_MODE.LABEL')}}
            <span v-if="deliveyMode.length" class="text_black_secondary">
              {{$t('ORDER.DETAILS.DELIVERY_MODAL.DELOVERY_MODE.DISTANCE')}}
              {{deliveyMode[0].distant}} Km
            </span>
          </label>
          <DeliveryMode
            v-for="(item,index) in deliveyMode"
            :item="item"
            :selectedMode="selectedMode"
            :handleChange="handleChangeMode"
            :isLastItem="index === deliveyMode.length - 1"
            :merchant="merchant"
            :key="item.id"
          />
        </div>


        <div class="">
          <woot-button
          class-names="" variant="primary" @click="onContinue"
          :is-loading="isLoadingDeliveryMode"
          :is-disabled="isLoadingDeliveryMode"
          >
          {{$t("ORDER.DETAILS.DELIVERY_MODAL.BTN.CONTINUE")}}
          </woot-button>
          <woot-button class-names="" variant="clear" @click="onClear">
          {{$t("ORDER.DETAILS.DELIVERY_MODAL.BTN.CLEAR")}}
          </woot-button>
        </div>

    </div>

  </ModalTemplate>
</template>

<script>
import WootSubmitButton from '../../../../components/buttons/FormSubmitButton.vue';
import Modal from '../../../../components/Modal.vue';
import alertMixin from 'shared/mixins/alertMixin';
import OrderAPI from "../../../../api/orders";
import { required, minLength, numeric , minValue,requiredIf } from 'vuelidate/lib/validators';
import InputField from 'components/ui/inputs/InputField.vue';
import MultiselectDropdown from 'components/ui/inputs/MultiselectDropdown.vue';
import ModalTemplate from 'dashboard/components/ModalTemplate.vue';
import OrderApi from 'dashboard/api/orders.js';
import DeliveryMode from 'shopApp/routes/shop/merchant/cart_components/DeliveryMode.vue';
import moment from "moment";

export default {
    components: {
        WootSubmitButton,
        Modal,
        InputField,
        MultiselectDropdown,
        ModalTemplate,
        DeliveryMode,
    },
    mixins: [alertMixin,],
    props: {
      show: {
        type: Boolean,
        default: false,
      },
      order: {
        type: Object,
        default: {},
      },
      merchant: {
        type: Object,
        default: {},
      },
    },
    data(){
      return {
        isDelvaFetched: false,
        selectedMode: null,
        // selectedModeItem: null,
        deliveyMode:[],
        isLoadingDeliveryMode: false,
      }
    },
    validations:{
        order:{
            shipment_address: {
                line1: {
                    required
                },
                // line2: {required},
                city: {
                    required
                },
                state: {
                    required
                },
                postal_code: {
                    required
                },
                country: {
                    required
                }
            },
        },
    },
  methods:{
        // onClose
    closeModal(){
      this.order.deliveryModeItem = null;
      this.$emit('onClose')
    },
    async onContinue (){
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (!this.isDelvaFetched) {
        this.fetchDeliveryList();
        return
      }

      // select and close modal
      if (!this.order.deliveryModeItem) {
        this.showAlert("Please select a delivery option")
        return
      }
      this.$emit("onSuccess",this.selectedMode)
    },
    async fetchDeliveryList(){
      try {
         this.isLoadingDeliveryMode = true;
         this.isDelvaFetched = false;
        const {data} = await OrderApi.fetch_available_delivery({
          currency: this.order.currency,
          order_items: this.order.order_items.filter(el => el.quantity > 0).map(el=>({
            item_price: el.item_price,
            quantity: el.quantity,
            catalog_item_id: el.catalog_item_id,
          })),
          contact: {
              name: this.order.contact.name,
              phone_number: this.order.contact.phone_number,
          },
          shipment_address: {
            line1: this.order.shipment_address.line1,
            line2: this.order.shipment_address.line1 || "",
            city: this.order.shipment_address.city,
            state: this.order.shipment_address.state,
            country: this.order.shipment_address.country,
            postal_code: this.order.shipment_address.postal_code,
          }
        })

        let dataList = data.map(el=>{
        const estimated_packed_time = parseInt(this.merchant?.estimated_packed_time || '0')
        const duration = parseInt(el.duration / 60);  // if durarion is negative then show "Estimated Delivery not available"

        const totalMin = duration + estimated_packed_time;
        const durationM = moment.duration(totalMin, "minutes");
        const days = Math.floor(durationM.asDays());
        const hours = Math.floor(durationM.hours());
        const minutes = Math.floor(durationM.minutes());
        let timeString = [];
        if (days > 0) timeString.push(`${days} days`);
        if (hours > 0) timeString.push(`${hours} hours`);
        if (minutes > 0) timeString.push(`${minutes} mins`);

          // with duration+merchant.estimated apck time

          return {
            id: el.id,
            title: el.name,
            // time: duration + estimated_packed_time + ' min',
            time: el.duration > 0 ? timeString.join(', ') : this.$t('ORDER.DETAILS.DELIVERY_MODAL.DELOVERY_MODE.DELIVERY_NOT_AVAILABLE'),
            // amount: el.price.amount,
            amount: el.total_price,
            currency: el.price.currency,
            companyCode: el.companyCode,
            distant: el.distant,
          }
        })

        if (!this.merchant.paid_by_customer) {
          dataList = dataList.sort((a,b)=>a.amount - b.amount).slice(0,1);
        }

        this.deliveyMode = dataList;

        this.isLoadingDeliveryMode = false;
        this.isDelvaFetched = true;


      } catch (error) {
        console.log(error);
         this.isLoadingDeliveryMode = false;
      }
    },
    handleChangeMode(item){
      this.selectedMode = item.id;
      // this.selectedModeItem = item;
      this.order.deliveryModeItem = item;
    },
    onClear(){
      this.order.deliveryModeItem = null;
      this.closeModal()
    },
    onChange(){
      this.isDelvaFetched = false;
    },
    // end methods
  },
}
</script>

<style>

</style>